/*
 * Module for Action API Endpoints
 */

define([
  "marionette",
  "messaging/messenger",
  "backbone",
  "./apiConfigView",
  "modules/shared/sortableList/sortableListModule",
  "modules/authoringAdmin/apiConfigModal/apiConfigModalModule",
  "./apiConfigModel",
], function (
  Marionette,
  Messenger,
  Backbone,
  ApiConfigView,
  SortableListModule,
  ApiConfigModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "apiConfigs";
      this.region = options.region;
      this._setUpReqRes();
      this._setUpVents();
    },
    show: function () {
      //set no-op save
      Messenger.onSave(function () {
        console.log("saving api configuration");
        Messenger.saveAttempted(true);
      }, this);

      this.apiConfigs = Messenger.reqres.request("apis");
      this.layout = new ApiConfigView.apiConfigLayout();
      var headers = Messenger.reqres.request("api:config:headers");

      var extendedEvents = {
        "click #deleteApi": function () {
          Messenger.yesNoDialog(
            "admin.apiAdmin.confirmDeleteApi",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete API",
                  id: this.model.id,
                  idType: "API",
                  object: "API",
                });
                this.model.deleteModel();
              },
            },
            this,
          );
        },
      };
      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          extendedEvents: extendedEvents,
        }),
      );

      //add a new API to the list
      this.layout.on(
        "add:api",
        function () {
          var newItem = this.apiConfigs.addItem();
          //show the API config modal
          Messenger.vent.trigger(
            "show:modal",
            ApiConfigModalModule,
            {
              editMode: false,
            },
            newItem,
            {
              title: "admin.apiAdmin.addApi",
              closeButton: false,
              closeOnBackgroundClick: false,
              modalWidth: 550,
              trackInteraction: {
                action: "Add API",
                object: "API",
              },
            },
          );
        },
        this,
      );

      this.layout.on(
        "show",
        function () {
          this.list.show(this.apiConfigs);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _setUpVents: function () {
      //Show the API admin screen
      Messenger.vent.on(
        "show:authoring:admin:apis",
        function () {
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/authoringAdmin/apis");
          this.show();
        },
        this,
      );
      //a row was selected in the sortable list (prepend namespace)
      Messenger.vent.on(
        this.name + ":selected:row",
        function (model) {
          Messenger.vent.trigger(
            "show:modal",
            ApiConfigModalModule,
            {
              editMode: true,
            },
            model,
            {
              title: "admin.apiAdmin.editApi",
              closeButton: false,
              closeOnBackgroundClick: false,
              modalWidth: 550,
              trackInteraction: {
                action: "Edit API",
                id: model.id,
                idType: "API",
                object: "API",
              },
            },
          );
        },
        this,
      );
      //show the module
      Messenger.vent.on(
        "show:kb:admin:apis",
        function () {
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/authoringAdmin/apis");
          this.show();
        },
        this,
      );
    },
    _setUpReqRes: function () {
      Messenger.reqres.setHandler(
        "api:configs",
        function () {
          return this.apiConfigs;
        },
        this,
      );
    },
  });
});
